import type { CellMap } from './types';

/** The welcome motif drawn into a fresh library on first run. */
export function seedCells(rows = 25, cols = 25): CellMap {
  const cells: CellMap = {};
  const place = (r: number, c: number, color: string) => {
    if (r >= 0 && r < rows && c >= 0 && c < cols) cells[`${r}-${c}`] = { color, stitch: 'knit' };
  };
  const cx = Math.floor(cols / 2);
  const cy = Math.floor(rows / 2);
  if (rows >= 13 && cols >= 13) {
    for (let d = 0; d <= 6; d++) {
      place(cy - 6 + d, cx, d % 2 ? 'rust' : 'amber');
      place(cy + 6 - d, cx, d % 2 ? 'rust' : 'amber');
      for (let k = 0; k <= d; k++) {
        place(cy - 6 + d, cx - k, k === d ? 'mustard' : d % 2 ? 'rust' : 'amber');
        place(cy - 6 + d, cx + k, k === d ? 'mustard' : d % 2 ? 'rust' : 'amber');
      }
    }
    for (let k = 0; k <= 6; k++) {
      place(cy + k, cx - (6 - k), 'mustard');
      place(cy + k, cx + (6 - k), 'mustard');
    }
  }
  for (const [r, c] of [
    [0, 0],
    [0, cols - 1],
    [rows - 1, 0],
    [rows - 1, cols - 1],
  ])
    place(r, c, 'teal');
  return cells;
}
